module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQAgMAAADzfxo+AAAAAXNSR0IArs4c6QAAAAxQTFRFAAAAAAAAAAAAAAAANek3lgAAAAR0Uk5TAE2a5gkWXdQAAAAsSURBVDjLY2AYBSMX/IcDsgRD4WC4BMgqOCArQLBqH9IAaxRTmGxGwSjABQAd3WOdXO2VhAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list.png
// module id = TV/B
// module chunks = 167